import { Component, OnDestroy } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Auth } from '@content-platform/web-angular-shared-util-auth';

import {
  Application,
  userPermissionListSelectors,
} from '@content-platform/web/angular/shared/data-access/application-api';
import { CardDetails } from '@content-platform/reusable-ui/card';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { getAllApplicationCards } from '../selectors';

@Component({
  selector: 'app-platform-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnDestroy {
  isLoggedIn$: Observable<boolean>;
  appCards$: Observable<CardDetails[]>;
  appsSub: Subscription;
  allApps: Application[] = [];
  private logger: LoggerService;

  constructor(private store: Store<Auth>, loggerService: LoggerService) {
    this.appCards$ = store.pipe(select(getAllApplicationCards));
    this.logger = loggerService.instance('DashboardComponent');
    this.appsSub = this.store
      .pipe(select(userPermissionListSelectors.getDisplayableUserApplications))
      .subscribe((apps) => {
        this.allApps = apps;
      });
  }

  switchApp(card: CardDetails): void {
    if (!card.comingSoon) {
      const foundApp = this.allApps.find((app) => app.name === card.id);
      if (foundApp) {
        this.logger.log('Switch App', {
          appName: foundApp.name,
        });
        if (!foundApp.external) {
          window.location.href = foundApp.url;
        } else {
          window.open(foundApp.url, '_blank');
        }
      }
    }
  }

  ngOnDestroy() {
    this.appsSub.unsubscribe();
  }
}
